import $i from '~/i18n'
import * as actions from './actions'
import * as mutations from './mutations'

export default{
  namespaced:true,
  state: () => ({
    lengthList: 15,
    listMyTransaction: [],
    listMyTransactionLengthList: 1,
    listAllTransaction: [],
    listAllTransactionLengthList: 1,
    myEarnList: [],
    myEarnListlengths: 1,
    allEarnList: [],
    allEarnListlengths: 1,
    myHistory: [],
    AllAdjustmentTrue: [],
    AllAdjustmentTrueLengths: 1
  }),
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/accounting/index.js